module.exports = __webpack_public_path__ + "media/best-part-of-me.919cf6b4.mp3";